import { render, staticRenderFns } from "./SelectCategory.vue?vue&type=template&id=c3c9b276"
import script from "./SelectCategory.vue?vue&type=script&lang=js"
export * from "./SelectCategory.vue?vue&type=script&lang=js"
import style0 from "./SelectCategory.vue?vue&type=style&index=0&id=c3c9b276&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports